import { Component, OnInit } from '@angular/core';
import { KnowledgeBaseService, KBCategory, KBSearchResult } from '../../services/knowledge-base.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-kb-layout',
  templateUrl: './kb-layout.component.html',
  styleUrls: ['./kb-layout.component.css']
})
export class KbLayoutComponent implements OnInit {
  categories: KBCategory[] = [];
  searchQuery = '';
  searchResults: KBSearchResult[] = [];
  isSearching = false;

  constructor(private kb: KnowledgeBaseService, public auth: AuthService) {}

  ngOnInit() {
    this.kb.getCategories().subscribe(cats => this.categories = cats);
  }

  onSearch() {
    const q = this.searchQuery.trim();
    if (!q) {
      this.searchResults = [];
      this.isSearching = false;
      return;
    }
    this.isSearching = true;
    this.kb.search(q).subscribe(results => this.searchResults = results);
  }

  clearSearch() {
    this.searchQuery = '';
    this.searchResults = [];
    this.isSearching = false;
  }
}
